import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';

import Select, { Props as SelectProps } from 'components/Select';
import Formsy from 'lib/Formsy';
import Field from 'components/Field';
import Label from 'components/Label';

type Props = {
  /* label text */
  label?: React.ReactNode;
  /* hide label */
  labelHidden?: boolean;
  /* show error even when no change as been made to the input, default is FALSE */
  showErrorOnPristine?: boolean;
  onChange?: (value: any) => void;
  value?: any;
  name: string;
} & SelectProps;

const FormSelect = createReactClass<Props>({
  propTypes: {
    /* label text */
    label: PropTypes.node,
    /* hide label */
    labelHidden: PropTypes.bool,
    /* show error even when no change as been made to the input, default is FALSE */
    showErrorOnPristine: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.any,
    name: PropTypes.string.isRequired,
  },

  mixins: [Formsy.Mixin],

  getInitialState() {
    return {
      value: this.props.value,
    };
  },

  id: uniqueId('id-'),

  onChange(value: any) {
    this.setValue(value);
    this.setState({ value });
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  },

  renderLabel() {
    const { label } = this.props;

    if (label) {
      return (
        <Label htmlFor={this.id} hidden={this.props.labelHidden}>
          {label}
        </Label>
      );
    } else {
      return null;
    }
  },

  render() {
    let errorMessage = this.getErrorMessage();

    if (!this.props.showErrorOnPristine && this.isPristine()) {
      errorMessage = null;
    }

    return (
      <Field error={errorMessage}>
        {this.renderLabel()}
        <Select {...this.props} id={this.id} value={this.state.value} onChange={this.onChange} />
      </Field>
    );
  },
});

export default FormSelect;
